// extracted by mini-css-extract-plugin
module.exports = {"testimonial":"Testimonial-module--testimonial--10hXF","author":"Testimonial-module--author--bhb_3"};